<template>
    <div class="signup-fields-block">
        <div class="signup-fields-block--title">Вход в систему</div>
        <div class="fields-after">
            <main-input :placeholder="'Ваш email'" v-model="user.email"></main-input>
            <main-input :placeholder="'Ваш пароль'" v-model="user.password" :type="'password'"></main-input>
            <div class="buttons-block">
                <main-blue-button @click="signIn">
                    Вход в систему
                </main-blue-button>
                <div class="buttons-block--link" @click="$router.push({name: 'ForgotPassword'})">Забыли пароль?</div>
            </div>

        </div>
    </div>
</template>

<script>
import MainInput from '@/components/ui/inputs/MainInput.vue'
import MainBlueButton from '@/components/ui/buttons/MainBlueButton.vue'
import PreloaderButton from '@/components/preloader/PreloaderButton.vue'
import { mapGetters, mapMutations } from 'vuex';

export default {
    name: 'SignInfieldsBlock',
    components: { MainInput, MainBlueButton, PreloaderButton },
    data() {
        return {
            user: {
                email: '',
                password: ''
            },
        }
    },
    methods: {
        ...mapMutations(['SET_PRELOADER_BUTTON', 'SET_CUSTOM_ERROR']),
        signIn() {
            console.log('начали')
            this.SET_PRELOADER_BUTTON(true)
            setTimeout(() => {
                console.log('вход')
                //this.SET_PRELOADER_BUTTON(false)
                //this.SET_CUSTOM_ERROR({state: true, text: 'Системная ошибка при выполнении входа'})
                this.login()
            }, 2000)
        },
        login() {
            this.axios.post(process.env.VUE_APP_API_URL + '/api/login', this.user)
            .then(response => {
                localStorage.setItem('token', response.data.token)
                localStorage.setItem('is_admin', response.data.body.is_admin)
                localStorage.setItem('user_id', response.data.body.id)
                this.SET_PRELOADER_BUTTON(false)
                this.$router.push({name: 'AdminOrders'})
            })
            .catch(error => {
                this.SET_CUSTOM_ERROR({state: true, text: error.response.data.data})
                this.SET_PRELOADER_BUTTON(false)
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    .signup-fields-block {
        display: flex;
        width: 100%;
        height: fit-content;
        padding: 30px;
        flex-direction: column;
        background: #fff;
        border-radius: 7px;
        gap: 15px;
        box-sizing: border-box;
        &--title {
            display: flex;
            font-size: 16px;
            font-weight: 600;
        }
    }
    .margin-for-title {
        margin-top: 40px;
    }

    .fields-after {
        display: flex;
        flex-direction: column;
        gap: 15px;
        &--title {
            display: flex;
            font-size: 16px;
            font-weight: 600;
        }
        &--text {
            display: flex;
            font-size: 15px;
            font-weight: 500;
            line-height: 24px;
        }
    }

    .buttons-block {
        display: flex;
        margin-top: 30px;
        flex-direction: row;
        gap: 8px;
        width: 100%;
        justify-content: space-between;
        align-content: center;
        align-items: center;
        &--link {
            display: flex;
            font-size: 14px;
            color: blue;
            cursor: pointer;
            box-sizing: border-box;
            padding: 0px 5px;
            &:hover {
                text-decoration: underline;
            }
        }
    }

</style>